import { observer } from "mobx-react";
import AnalyticsFilter from "newApp/components/AnalyticsFilter";
import AnalyticsTable from "newApp/components/AnalyticsTable";
import AnalyticsNavigator from "newApp/components/AnalyticsNavigator";
import MainLayout from "newApp/components/layouts/MainLayout";
import Button from "newApp/kit/components/Button";
import ButtonsContainer from "newApp/kit/components/ButtonsContainer";
import FlexColumn from "newApp/kit/components/FlexColumn";
import H1 from "newApp/kit/components/H1";
import LoaderSpinner from "newApp/kit/components/LoaderSpinner";
import { AnalyticsInWorkPageStore } from "newApp/stores/pages/analytics/AnalyticsInWorkPageStore";
import React, { useEffect } from "react";

const store = new AnalyticsInWorkPageStore();

const AnalyticsInWorkPage: React.FC = () => {
  useEffect(() => {
    store.init();
    return () => store.reset();
  }, []);

  return (
    <MainLayout>
      <H1>Аналитика - В работе</H1>
      <FlexColumn>
        <AnalyticsNavigator />
        <ButtonsContainer>
          <AnalyticsFilter
            filter={store.filter}
            getList={() => store.getReport()}
          />
          <a href={store.downloadUrl} target="_blank" rel="noreferrer">
            <Button onClick={() => {}} variant="secondary" size="small">
              Скачать таблицу
            </Button>
          </a>
        </ButtonsContainer>
        {store.isLoadings.getReport ? (
          <LoaderSpinner />
        ) : (
          <AnalyticsTable table={store.table} />
        )}
      </FlexColumn>
    </MainLayout>
  );
};

export default observer(AnalyticsInWorkPage);
